import { Theme } from '../enums/theme.enum';

export function getWidgetTextColor() {
	const root = document.documentElement;
	const isDark = root.classList.contains(Theme.DARK);

	const varName = isDark ? '--color-secondary-900' : '--color-secondary-600';
	return getComputedStyle(root).getPropertyValue(varName).trim();
}

export function getWidgetGridColor() {
	const root = document.documentElement;
	const isDark = root.classList.contains(Theme.DARK);

	const varName = isDark ? '--color-secondary-400' : '--color-secondary-200';
	return getComputedStyle(root).getPropertyValue(varName).trim();
}

export function getWidgetFontFamily() {
	return getComputedStyle(document.body).fontFamily;
}

export function getColor(col: string) {
	const root = document.documentElement;
	return getComputedStyle(root).getPropertyValue(col).trim();
}

export function getColorHex(name: string) {
	if (!name) {
		return '';
	}
	const root = document.documentElement;

	const parsed = name.replace(/^var\(|\)$/g, '');
	return getComputedStyle(root).getPropertyValue(parsed).trim();
}
